module.exports = __webpack_public_path__ + "img/art.b8e8484.jpg";